$.post(
  'https://www.qetail.com/apps/ajaxifycart/Auth/getresult',
  {
    shop_url:shop_url
  }).done(function(response){
  data = JSON.parse(response);
  $enableapp=data[0].enableapp;
  $button_text=data[0].button_text;
  $button_text_color=data[0].button_text_color;
  $button_background_color=data[0].button_background_color;
  $checkdone=data[0].checkdone;
  $enable_annoncementbar=data[0].enable_annoncementbar;
  $annoncementbar_text=data[0].annoncementbar_text;
  $annoncementbar_background_color=data[0].annoncementbar_background_color;
  $annoncementbar_text_color=data[0].annoncementbar_text_color;
  $drawer_text_color=data[0].drawer_text_color;
  $drawer_background_color=data[0].drawer_background_color;
  $drawer_fontsize=data[0].drawer_fontsize;
  $drawer_enable_cartbutton=data[0].drawer_enable_cartbutton;
  $drawer_enable_checkoutbutton=data[0].drawer_enable_checkoutbutton;
  $drawer_enable_continueshopping=data[0].drawer_enable_continueshopping;
  $drawer_enable_promocode=data[0].drawer_enable_promocode;
  $drawer_enable_note=data[0].drawer_enable_note;
  $drawer_enable_shippingbar=data[0].drawer_enable_shippingbar;
  $drawer_enable_relatedproducts=data[0].drawer_enable_relatedproducts;
  $shippingbar_limit=data[0].shippingbar_limit * 100;
  $shippingbar_text_color=data[0].shippingbar_text_color;
  $shippingbar_background_color=data[0].shippingbar_background_color;
  $enable_drawer = data[0].enable_drawer;
  $enable_popup = data[0].enable_popup;
  // App Admin Settings Start

  if($enableapp == 'on' && ($enable_drawer  == 'on' || $enable_popup == 'on'))
  {
    $('.js-ajax-add-to-cart').html($button_text); 
    $('.product-form__cart-submit, .js-ajax-add-to-cart, .ajax-cart-btn .js-button, .ajax-cart-checkout .js-button, .js-button').css("color",'#'+$button_text_color);
    $('.product-form__cart-submit, .js-ajax-add-to-cart, .ajax-cart-btn .js-button, .ajax-cart-checkout .js-button, .js-button').css("background-color",'#'+$button_background_color);
    if($enable_annoncementbar == null){$('.modal-title').css("display","none");}
    else{$('.modal-title').html($annoncementbar_text);$('.modal-header').css("background-color",'#'+$annoncementbar_background_color);
         $('.modal-title').css("color",'#'+$annoncementbar_text_color);}
    $('.modal-content').css("color",'#'+$drawer_text_color);$('.modal-content').css("background-color",'#'+$drawer_background_color);
    $('.modal-content').css("font-size",$drawer_fontsize);  
    if($drawer_enable_cartbutton == null){ $('.ajax-cart-btn').css("display","none");}
    if($drawer_enable_checkoutbutton == null){ $('.ajax-cart-checkout').css("display","none");}
    if($drawer_enable_continueshopping == null){$( "body" ).append( "<style>.continue_shopping{display:none !important;}</style>" );}
    if($drawer_enable_promocode == null){$( "body" ).append( "<style>.cart-promo{display:none !important;}</style>" );}
    if($drawer_enable_note == null){$( "body" ).append( "<style>.cartNoteBox{display:none !important;}</style>" );}
    if($drawer_enable_shippingbar == null){$( "body" ).append( "<style>.cart-shipping__wrapper{display:none !important;}</style>" );}else{
      $( "body" ).append( "<style>.cart-shippingThreshold__progress{background-color:#"+$shippingbar_background_color+" !important;}</style>" );
      $( "body" ).append( "<style>.cart-shipping__success, .cart-shipping__numOuter, .cart-shipping__num{color:#"+$shippingbar_text_color+" !important;}</style>" );
    }
    if($drawer_enable_relatedproducts == null){$( "body" ).append( "<style>.relProductsDiv{display:none !important;}</style>" );}
    // App Admin Settings End
    const defaults = {
      cartModal: '.js-ajax-cart-modal', // classname
      cartModalContent: '.js-ajax-cart-modal-content', // classname
      cartModalClose: '.js-ajax-cart-modal-close', // classname
      cartDrawer: '.js-ajax-cart-drawer', // classname
      cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
      cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
      cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
      cartOverlay: '.js-ajax-cart-overlay', // classname
      cartCounter: '.js-ajax-cart-counter', // classname
      addToCart: '.js-ajax-add-to-cart', // classname
      removeFromCart: '.js-ajax-remove-from-cart', //classname
      removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
      checkoutButton: '.js-ajax-checkout-button',
      updateToCart: '.js-ajax-cart-quantity',
      cartAutoDiscount: '.ajax-cart-drawer_auto-discount',
    };

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
let updateToCart = document.querySelectorAll(defaults.updateToCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;
const cartAutoDiscount = document.querySelectorAll(defaults.cartAutoDiscount);

for (let i = 0; i < addToCart.length; i++) {
    addToCart[i].addEventListener('click', function(event) {
        event.preventDefault();
        const formID = $(this).parents("form").attr('id');
        addProductToCart(formID);
    });
}
function addProductToCart(formID) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: addToCartOk,
        error: addToCartFail,
    });
}
function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
        onCartUpdate(cart);
    if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = '<h3>Cart is empty</h3>';
                checkoutButton.classList.add('is-hidden');
                $('.cart-promo').css("display","none");
               $('.cart-shipping__wrapper').css("display","none");
                $('.js-ajax-cart-modal-content').css("display","none");
               $('.relProductsDiv').css("display","none");
                $('.js-button').css("display","none");
                
            } else {
              
               $('.cart-promo').css("display","");
               $('.cart-shipping__wrapper').css("display","");
               $('.js-ajax-cart-modal-content').css("display","");
               $('.relProductsDiv').css("display","");
                $('.js-button').css("display","");
              renderCart(cart);
                checkoutButton.classList.remove('is-hidden');
            }
            calculateProgress(cart.total_price, $shippingbar_limit);
        },
    });
}

function changeItem(line, callback) {
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
                 calculateProgress(cart.total_price, $shippingbar_limit);
                if (cart.item_count === 0) {
                  $('.cart-promo').css("display","none");
               $('.cart-shipping__wrapper').css("display","none");
               $('.js-ajax-cart-modal-content').css("display","none");
               $('.relProductsDiv').css("display","none");
                $('.js-button').css("display","none");
                }
            }
        },
    });
}

function updateItem(line, qty, callback) {
    const quantity = parseInt(qty);
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart(); 
                 calculateProgress(cart.total_price, $shippingbar_limit);
            }
        },
    });
}

function onCartUpdate(cart) {}
function addToCartOk(product) {
    cartModalContent.innerHTML = product.title + ' was added to the cart!';
    cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
    openAddModal();
    openCartOverlay();
    fetchCart();
}
function removeProductFromCart() {cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;}
function addToCartFail() {
    cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
    openAddModal();
    openCartOverlay();
}
function renderCart(cart) {
  clearCartDrawer();
  cart.items.forEach(function(item, index) {
      const productImage = '<div class="ajax-cart-pro-img">' + '<img class="ajax-cart-item__image" src="' + item.image + '" >' + '</div>';
        const productTitle = '<div class="ajax-cart-item__title"><a href="'+item.url+'">' + item.title + '</a></div>';
        const productPrice = '<div class="ajax-cart-item__price">' + cart.currency  +" "+  item.line_price/100 + '</div>';
        const productQuantity = '<div class="ajax-cart-item__quantity">' + '<input type="number" id="Quantity_'+item.id+'" name="quantity" value="'+ item.quantity +'" min="1" class="product-form__input product-form__quantity js-ajax-cart-quantity">' + '</div>';
        const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '">' + '<svg width="9" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#cacaca" fill-rule="nonzero"></path></svg>' + '</div>';
      const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + productImage + productTitle + productQuantity + productPrice + productRemove + '</div>';
     cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
	});
    const appendmore = '<div><span class="subtotal"><h3>SUBTOTAL '+cart.currency  +" "+ cart.items_subtotal_price/100+'</h3></span></div>';
    const note = '<div class="cartNoteBox"> <label for="CartNote">Special instructions</label><textarea name="note" id="CartNote">'+(cart.note?cart.note:"")+'</textarea></div>'; 
    const autoDiscount = cart.cart_level_discount_applications;
    $(".ajax-cart-drawer_auto-discount").html("");
    $(".cart-promo").show();
    var cartAutoDiscountContent = '';
    for(ad=0;ad<autoDiscount.length;ad++){
    $(".cart-promo").hide();    
    cartAutoDiscountContent += '<div class="ajax-cart-discounts">';
    cartAutoDiscountContent += '<span class="order-discount order-discount--title order-discount--cart">';
    cartAutoDiscountContent += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg>';
    cartAutoDiscountContent += '<span class="visually-hidden" style="display:none;">Discount:</span>';
    cartAutoDiscountContent += '<span data-cart-discount-title="">'+autoDiscount[ad].title+'</span>';
    cartAutoDiscountContent += '</span>';
    cartAutoDiscountContent += '<span class="order-discount order-discount--cart">';
    cartAutoDiscountContent += '<strong>-<span data-cart-discount-amount="">'+cart.currency+' '+autoDiscount[ad].total_allocated_amount/100+'</span></strong>';
    cartAutoDiscountContent += '</span>';
    cartAutoDiscountContent += '</div>';
  }
    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + appendmore + cartAutoDiscountContent + note;
    removeFromCart = document.querySelectorAll(defaults.removeFromCart);
    for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
            const line = this.parentNode.getAttribute('data-line');
            changeItem(line);
        });
    }
    updateToCart = document.querySelectorAll(defaults.updateToCart);
    for (let i = 0; i < updateToCart.length; i++) {
        updateToCart[i].addEventListener('change', function() {
            const line = $(this).parents(".ajax-cart-item__single").attr('data-line');
            const qty = $(this).val();
            updateItem(line, qty);
        });
    }
  	$('.related-pro-slide').slick('unslick');
	$('.related-pro-slide').slick({
    	slidesToShow: 1,
    	slidesToScroll: 1
 	 });
 }
function openCartDrawer() { cartDrawer.classList.add('is-open'); }
function closeCartDrawer() { cartDrawer.classList.remove('is-open');}
function clearCartDrawer() {cartDrawerContent.innerHTML = ''; }
function openAddModal() { cartModal.classList.add('is-open');}
function closeAddModal() { cartModal.classList.remove('is-open');}
function openCartOverlay() {
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
}
function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}
cartModalClose.addEventListener('click', function() {
    closeAddModal();
    closeCartOverlay();
});
cartOverlay.addEventListener('click', function() {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
});

cartDrawerTrigger.addEventListener('click', function(event) {
    event.preventDefault();
    openCartDrawer();
    openCartOverlay();
});

document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});

checkoutButton.addEventListener('click', function(event) {
  event.preventDefault();
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + $("#CartNote").val(),
        dataType: 'json',
        success: function(result) {
          var theUrl = '/checkout?discount=';
          var theDiscount = $('#devPromo').val();
          var toRedirect = theUrl+theDiscount;
          window.location.href = toRedirect;
        },
    });    
});
function calculateProgress(currentVal, targetVal) {
  var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
  var progressNum = document.querySelectorAll('.cart-shipping__num');
  var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
  var successMsg = document.querySelectorAll('.cart-shipping__success');
  var result = Math.round(100 * currentVal / targetVal);
  progressBar.forEach(function(el){
    el.setAttribute('style', "width: ".concat(result, "%"));
  })
  var newProgressNum = (targetVal - currentVal) / 100;
  if(newProgressNum <= 0){
    successMsg.forEach(function(el){
      el.setAttribute('style', 'display: block;');
    });
    progressOuter.forEach(function(el){
      el.setAttribute('style', 'display: none;');
    });
    progressNum.forEach(function(el){
      el.textContent = newProgressNum;
    });
  } else {
    successMsg.forEach(function(el){
      el.setAttribute('style', 'display: none;');
    });
    progressOuter.forEach(function(el){
      el.setAttribute('style', 'display: block;');
    });
    progressNum.forEach(function(el){
      el.textContent = newProgressNum;
    });
  }
};

$.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  success: function(cart){
    calculateProgress(cart.total_price, $shippingbar_limit);

  }
});

  $(document).ready(function(){
  $('[name="add"]').eq(0).hide();
  $('[name="add"]').eq(0).after($('[name="add"]').eq(1));
  $('a[href="/cart"], [name="add"]').on('click',function(event){
    event.preventDefault();
    $('a[href="/cart"]').attr('data-toggle','modal');
    $('#myModal2').css("display","block");
    $('#myModal2').addClass("in");
    fetchCart();
    $('.js-ajax-cart-modal-close').on('click',function(){
    $('#myModal2').css("display","none");  
    });  
    
  });
  
  $('#redemDevPromo').on('click', function(event){
    event.preventDefault();
    checkoutButton.click();
  }); 
  setInterval(function(){ 
  $('.related-pro-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1
    });
    }, 2000);  

  });

}else
  {
    $('.js-ajax-add-to-cart').css("display","none");
  }
 });
         